module.exports = __webpack_public_path__ + "img/symbol_6.53519daf.png";